module.exports = __webpack_public_path__ + "img/活鲜.55b9d45c.png";